import { injectable, inject } from 'inversify';

import IHelpDeskProvider from './i-helpdesk-provider';
import { ActionResult, ErrorTypes } from '../Common';
import OrderSearchFilter from './order-filtred';
import { RestClient } from 'typed-rest-client';
import { Order } from './order-info';
import { Ticket } from './ticket-data';
import { RefundRequest } from './refund-request';
import { IContext } from '../Identity';
import { IdentitySymbols } from '../Identity/symbols';
import { AppSettings } from '../Global/app-settings';
import GlobalService from '../Global/global-service';


@injectable()
export default class DefaultHelpDeskProvider implements IHelpDeskProvider {
    protected _context: IContext;
    protected _appSettings: AppSettings;

    constructor(@inject(IdentitySymbols.Context) context: IContext) {
        this._context = context;
        this._appSettings = GlobalService.GetSettings();
    }

    private GetRestClient(): RestClient {
        /* Friendly RestClient reminder
         * .get() = GET
         * .create() = POST
         * .replace() = PUT
         */
        let client: RestClient = new RestClient('help-app', this._appSettings.HelpAddress, [], {});
        return client;
    };

    async FindByPaymentCodeAsync(code: string, email: string, phone: string): Promise<ActionResult<Order>> {
        let client: RestClient = new RestClient('help-app', this._appSettings.HelpAddress, [], {
            headers: { /*"Authorization": `Bearer ${this.accessToken}`*/ }
        });

        let filter = new OrderSearchFilter();
        filter.PaymentCode = code;
        filter.Email = email;
        filter.Phone = phone;

        try {
            let response = await client.create<AjaxResult<Order>>(this._appSettings.HelpAddress + `/api/order/bypaymentcode`, filter);

            if (response.statusCode === 401 || response.statusCode === 403 || response.statusCode === 404) {
                return ActionResult.Failed(ErrorTypes.InternalError);
            }

            if (response.result?.result != 1) {
                return ActionResult.SuccessData(response.result?.data)
            } else {
                return ActionResult.Failed(ErrorTypes.InternalError, response.result?.message);
            }
        } catch (e) {
            return ActionResult.Failed(ErrorTypes.InternalError, "Сервис временно недоступен! Приносим извинения за доставленные неудобства");
        }
    }

    async GetTicketDataAsync(orderId: number, orderItemId: number, access_token: string): Promise<ActionResult<Ticket>> {
        let client: RestClient = new RestClient('help-app', this._appSettings.HelpAddress, [], { headers: { "Authorization": `Bearer ${access_token}` } });
        try {
            let response = await client.get<AjaxResult<Ticket>>(this._appSettings.HelpAddress + `/api/order/ticket?id=${orderItemId}&token=${access_token}`);
            if (response.statusCode === 401 || response.statusCode === 403) {
                return ActionResult.Failed(ErrorTypes.InternalError);
            }

            if (response.result?.result != 1) {
                return ActionResult.SuccessData(response.result?.data);
            }
            else {
                return ActionResult.Failed(ErrorTypes.InternalError, response.result?.message);
            }
        } catch (e) {
            return ActionResult.Failed(ErrorTypes.InternalError, "Сервис временно недоступен! Приносим извинения за доставленные неудобства");
        }
    }

    async FindByLinkParametersAsync(sign: string, orderId: number, email: string, phone: string): Promise<ActionResult<Order>> {
        let client: RestClient = new RestClient('help-app', this._appSettings.HelpAddress, [], { headers: { /*"Authorization": `Bearer ${this.accessToken}`*/ } });

        try {
            //https://localhost:44383/order/details?sign=adfhbgjadfhbgkdfsh&orderId=16892&email=ura.so.v.ru%40mail.ru&phone=%2079251066154
            let response = await client.create<AjaxResult<Order>>(this._appSettings.HelpAddress + `/api/order/byorderid/signed?sign=${sign}&orderId=${orderId}&email=${email}&phone=${phone}`, null);

            if (response.statusCode == 401 || response.statusCode == 403 || response.statusCode == 404) {
                return ActionResult.Failed(ErrorTypes.InternalError);
            } else {
                if (response.result?.result != 1) {
                    return ActionResult.SuccessData(response.result?.data);
                } else {
                    return ActionResult.Failed(ErrorTypes.InternalError, response.result?.message);
                };
            };
        } catch (e) {
            return ActionResult.Failed(ErrorTypes.InternalError, "Сервис временно недоступен! Приносим извинения за доставленные неудобства");
        };
    };

    async FindByCodeAsync(orderCode: number, email: string, phone: string): Promise<ActionResult<Order>> {
        let client: RestClient = new RestClient('help-app', this._appSettings.HelpAddress, [], {
            headers: { /*"Authorization": `Bearer ${this.accessToken}`*/ }
        });
        let filter = new OrderSearchFilter();
        filter.OrderCode = orderCode;
        filter.Email = email;
        filter.Phone = phone;

        try {
            let response = await client.create<AjaxResult<Order>>(this._appSettings.HelpAddress + `/api/order/bycode`, filter);
            if (response.statusCode === 401 || response.statusCode === 403 || response.statusCode == 404) {
                return ActionResult.Failed(ErrorTypes.InternalError);
            }

            if (response.result?.result != 1) {
                return ActionResult.SuccessData(response.result?.data);
            } else {
                console.log(response.result?.message);
                return ActionResult.Failed(ErrorTypes.InternalError, response.result?.message);
            }
        } catch (e) {
            return ActionResult.Failed(ErrorTypes.InternalError, "Сервис временно недоступен! Приносим извинения за доставленные неудобства");
        }
    };

    async FindByIdAsync(orderId: string, email: string, phone: string): Promise<ActionResult<Order>> {
        let client: RestClient = new RestClient('help-app', this._appSettings.HelpAddress, [], {
            headers: { /*"Authorization": `Bearer ${this.accessToken}`*/ }
        });

        let filter = new OrderSearchFilter();
        filter.OrderId = orderId;
        filter.Email = email;
        filter.Phone = phone;

        try {
            let response = await client.create<AjaxResult<Order>>(this._appSettings.HelpAddress + `/api/order/bypaymentcode`, filter);

            if (response.statusCode === 401 || response.statusCode === 403 || response.statusCode === 404) {
                return ActionResult.Failed(ErrorTypes.InternalError);
            }

            if (response.result?.result != 1) {
                return ActionResult.SuccessData(response.result?.data)
            } else {
                return ActionResult.Failed(ErrorTypes.InternalError, response.result?.message);
            }
        } catch (e) {
            return ActionResult.Failed(ErrorTypes.InternalError, "Сервис временно недоступен! Приносим извинения за доставленные неудобства");
        }
    };

    // http://redmine.isd.su/issues/8412
    async RequestRefundAsync(refund: any): Promise<ActionResult> {
        let client = this.GetRestClient();

        try {
            let query = await client.create<AjaxResult<object>>(`/api/order/refund/set`, refund);
            if (query.result?.result == 0)
                return ActionResult.SuccessData(query.result?.data);

            return ActionResult.Failed(ErrorTypes.InternalError, query.result?.message);
        } catch (e) {
            return ActionResult.Failed(ErrorTypes.InternalError, "Сервис временно недоступен! Приносим извинения за доставленные неудобства");
        }
    };
    async ApproveRefundAsync(order: Order): Promise<ActionResult> {
        return ActionResult.Failed(ErrorTypes.InternalError);
    };
    async DeclineRefundAsync(order: Order): Promise<ActionResult> {
        return ActionResult.Failed(ErrorTypes.InternalError);
    };
    async GetRefundsAsync(status: number, page: number = 1, pageCount: number = 20): Promise<ActionResult<Array<RefundRequest>>> {
        let client: RestClient = new RestClient('help-app', window.location.origin, [], {
            headers: {
                "Authorization": `Bearer ${this._context.CurrentIdentity.AccessToken.Token}`
            }
        });
        try {
            let response = await client.get<Array<Object>>(`/api/refunds/?status=${status}&page=${page}&pageCount=${pageCount}`);
            if (response.statusCode != 200)
                return ActionResult.FailedData(ErrorTypes.InternalError, new Array(), "Не удалось получить информацию о заявках");

            return ActionResult.SuccessData((response.result as Array<RefundRequest>));
        } catch (e) {
            return ActionResult.FailedData(ErrorTypes.InternalError, new Array(), "Произошла внутренняя ошибка");
        };
    };

};

class AjaxResult<T> {
    result: number = 0;
    message: string = '';
    data?: T;
};